export const BACKEND_DATE_FORMAT = "YYYY-MM-DD";
export const BACKEND_DATETIME_FORMAT = "YYYY-MM-DD HH:mm:ss";
export const BACKEND_SUPPORT_TICKET_SCHEDULING_DATETIME_FORMAT =
  "YYYY-MM-DD HH:mm:00";
